<template>
  <div>
    <!-- 添加广告对话框 -->
    <el-dialog
      title="添加广告"
      :visible.sync="addDialogVisible"
      width="80%"
      append-to-body
      @close="addDialogClosed"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="rules"
        label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="广告类型" prop="advertiseType">
              <el-select v-model="addForm.enumType" clearable placeholder="请选择广告类型" style="width: 100%"
                         @change="selectAdvertiseType">
                <el-option
                  v-for="item in advertise"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="小程序路径" prop="page">
              <el-input v-model="addForm.page" placeholder="请输入小程序路径" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="enumEnable">
              <el-select v-model="addForm.enumEnable" clearable placeholder="请选择是否启用" style="width: 100%">
                <el-option key="NORMAL" label="是" value="NORMAL"></el-option>
                <el-option key="DISABLE" label="否" value="DISABLE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片广告" v-if="addForm.enumType==='PICTURE'">
              <thumbnail v-model="addForm.content" :md5s="addForm.content"></thumbnail>
            </el-form-item>
            <el-form-item label="视频广告" v-if="addForm.enumType==='VIDEO'">
              <QqVideo v-model="addForm.content" :videoMd5="addForm.content"></QqVideo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAdvertise">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QqVideo from '@/components/common/qqVideo/qqVideo'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import { addAdvertise } from '@/api/advertise/advertise'
import { getData } from '@/utils/code'
import { ADVERTISE } from '@/js/enum'
import { advertisRules } from '@/js/rules'

export default {
  name: 'addAdvertise',
  components: { QqVideo, Thumbnail },
  data() {
    return {
      advertise: ADVERTISE,
      addForm: {
        enumEnable: 'NORMAL'
      },
      addDialogVisible: false,
      // 规则
      rules: advertisRules
    }
  },
  methods: {
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },
    addDialog() {
      this.addDialogVisible = true
    },
    // 监听添加对话框的关闭事件，重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addAdvertise() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        addAdvertise(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false
          }
        })
      })
    },
    selectAdvertiseType() {
      this.addForm.content = ''
    }

  }
}
</script>

<style scoped>

</style>
